// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Widths } from "./widths";

/**
 * One arm of an enum map. An empty `widths` matches any payload width.
 */
export class Case implements flatbuffers.IUnpackableObject<CaseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Case {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCase(bb: flatbuffers.ByteBuffer, obj?: Case): Case {
    return (obj || new Case()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsCase(bb: flatbuffers.ByteBuffer, obj?: Case): Case {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Case()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  values(index: number): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt64(this.bb!.__vector(this.bb_pos + offset) + index * 8) : 0n;
  }

  valuesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  widths(): Widths {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Widths.W1;
  }

  member(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  assertNone(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startCase(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addValues(builder: flatbuffers.Builder, valuesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valuesOffset, 0);
  }

  static createValuesVector(builder: flatbuffers.Builder, data: bigint[]): flatbuffers.Offset {
    builder.startVector(8, data.length, 8);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt64(data[i]!);
    }
    return builder.endVector();
  }

  static startValuesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 8);
  }

  static addWidths(builder: flatbuffers.Builder, widths: Widths) {
    builder.addFieldInt8(1, widths, Widths.W1);
  }

  static addMember(builder: flatbuffers.Builder, member: number) {
    builder.addFieldInt16(2, member, 0);
  }

  static addAssertNone(builder: flatbuffers.Builder, assertNone: boolean) {
    builder.addFieldInt8(3, +assertNone, +false);
  }

  static endCase(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // values
    return offset;
  }

  static createCase(
    builder: flatbuffers.Builder,
    valuesOffset: flatbuffers.Offset,
    widths: Widths,
    member: number,
    assertNone: boolean,
  ): flatbuffers.Offset {
    Case.startCase(builder);
    Case.addValues(builder, valuesOffset);
    Case.addWidths(builder, widths);
    Case.addMember(builder, member);
    Case.addAssertNone(builder, assertNone);
    return Case.endCase(builder);
  }

  unpack(): CaseT {
    return new CaseT(
      this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength()),
      this.widths(),
      this.member(),
      this.assertNone(),
    );
  }

  unpackTo(_o: CaseT): void {
    _o.values = this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength());
    _o.widths = this.widths();
    _o.member = this.member();
    _o.assertNone = this.assertNone();
  }

  unpackFields(...fields: string[]): CaseT {
    const t = new CaseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("values")) {
      t.values = this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength());
    }
    if (fieldSet.has("widths")) {
      t.widths = this.widths();
    }
    if (fieldSet.has("member")) {
      t.member = this.member();
    }
    if (fieldSet.has("assert_none")) {
      t.assertNone = this.assertNone();
    }
    return t;
  }
}

export class CaseT implements flatbuffers.IGeneratedObject {
  constructor(
    public values: bigint[] = [],
    public widths: Widths = Widths.W1,
    public member: number = 0,
    public assertNone: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.values === null || this.values === undefined) {
      throw new Error('Required field "values" is not set');
    }
    const values = Case.createValuesVector(builder, this.values);

    return Case.createCase(builder, values, this.widths, this.member, this.assertNone);
  }

  clone(): CaseT {
    const obj = new CaseT();
    obj.values = [...this.values];
    obj.widths = this.widths;
    obj.member = this.member;
    obj.assertNone = this.assertNone;
    return obj;
  }

  equals(other: CaseT): boolean {
    if (this.values.length !== other.values.length) return false;
    for (let i = 0; i < this.values.length; i++) {
      if (this.values[i] !== other.values[i]) return false;
    }
    if (this.widths !== other.widths) return false;
    if (this.member !== other.member) return false;
    if (this.assertNone !== other.assertNone) return false;
    return true;
  }
}

export function verifyCase(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVector(pos, 8);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "values");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 2);
    verifier.checkScalarField(tablePos, 10, 1);
  } finally {
    verifier.popDepth();
  }
}
